<template>
  <v-container fluid
               v-if="template">

    <PageTitle icon="fas fa-fw fa-envelope">
      <div>
        Edit Email Template
      </div>

      <template v-slot:buttons>
        <v-btn @click.prevent="submit(false)"
               :disabled="form.busy"
               color="primary"
               class="mr-2">
          Save
        </v-btn>

        <v-btn v-if="1===2"
               @click.prevent="submit(true)"
               :disabled="form.busy"
               class="mr-2">
          Save and close
        </v-btn>

        <v-menu offset-y bottom
                :disabled="form.busy">
          <template v-slot:activator="{on, attrs}">
            <v-btn v-on="on"
                   v-bind="attrs">
              Actions
              <v-icon right>
                fal fa-fw fa-chevron-down
              </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item :href="template.send_email_url"
                         target="_blank">
              <v-list-item-content>
                <v-list-item-title>
                  Send Test
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <ShareTemplateImageDialog :template="template">
              <template #activator="{ on, attrs, openDialog }">
                <v-list-item v-bind="attrs"
                             v-on="on"
                             @click="openDialog">
                  <v-list-item-title>
                    Quick View
                  </v-list-item-title>
                </v-list-item>
              </template>
            </ShareTemplateImageDialog>
            <v-list-item v-if="template.is_unlayer"
                         :to="{name: 'admin.share_template.unlayer.edit', params: {templateID: template.id}}">
              <v-list-item-title>
                Edit Design
              </v-list-item-title>
            </v-list-item>
            <v-list-item :to="{name: 'admin.share_template.show', params: {templateID: template.id}}" exact>
              <v-list-item-content>
                <v-list-item-title>
                  Performance
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="1===2 && team.email_composer_enabled === false && team.campaigns_enabled && form.is_campaign"
                         :href="template.send_campaign_url"
                         target="_blank">
              <v-list-item-content>
                <v-list-item-title>
                  Send Test Campaign
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="canTestEmailTemplates && form.html_body"
                         :to="{name: 'admin.mailgun.email_preview.create', query: {template_id: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Create Email Preview Test
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="1===2 && spamTestEnabled && form.html_body && template">
              <v-list-item-content>
                <v-list-item-title>
                  Check for Spam
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="form.can_be_copied"
                         :to="{name: 'admin.share_template.create', query: {source: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Copy Template
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="form.can_be_copied && isOnOtherTeams"
                         :to="{name: 'admin.share_template.copy_to_team', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Copy to Another Team
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click.prevent="downloadPDF">
              <v-list-item-content>
                <v-list-item-title>
                  Download PDF
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'admin.share_template.audit_trail', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Audit Trail
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{name: 'admin.share_template.delete', params: {templateID: template.id}}">
              <v-list-item-content>
                <v-list-item-title>
                  Delete
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>

      </template>
    </PageTitle>

    <v-form @submit.prevent="submit(false)"
            :disabled="form.busy">
      <ShareTemplateForm v-if="$root.isAdminRoute"
                         :form="form"
                         :template="template">
      </ShareTemplateForm>
      <MemberShareTemplateForm v-else
                               :form="form"
                               :template="template">
      </MemberShareTemplateForm>

      <v-card>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Save
          </v-btn>

          <v-btn type="button"
                 @click.prevent="submit(true)"
                 :disabled="form.busy">
            Save and close
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn type="button"
                 :to="{name: 'admin.share_template.delete', params: {templateID: template.id}}"
                 :disabled="form.busy"
                 color="error">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {isObject} from 'lodash';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import moment from 'moment-timezone';
import ShareTemplateForm from './components/ShareTemplateForm';
import MemberShareTemplateForm from "./library/MemberShareTemplateForm";
import PageTitle from '../../components/PageTitle.vue';
import ShareTemplateImageDialog from './components/ShareTemplateImageDialog.vue';

export default {
  components: {ShareTemplateImageDialog, PageTitle, MemberShareTemplateForm, ShareTemplateForm},
  data() {
    return {
      form: new Form(shareTemplateService.initForm(false)),
      subjectLines: [], // MLD-6517
      template: null,
    }
  },
  computed: {
    ...mapGetters([
      'canTestEmailTemplates',
      'isOnOtherTeams', // MLD-3800
      'spamTestEnabled', // MLD-4012
      'team',
      'user',
      'users',
    ]),
    ...mapGetters('content', [
      'folders',
    ]),
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
    isAccessEveryone() {
      return this.form.accessControl === 'Everyone';
    },
    isAccessGroups() {
      return this.form.accessControl === 'Groups';
    },
    isAccessUser() {
      return this.form.accessControl === 'User';
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async downloadPDF() { // MLD-7683
      await shareTemplateService.downloadPDF(this.template, {});
    },
    async fetchData() {
      this.template = await this.fetchTemplate();
      this.subjectLines = await shareTemplateService.getSubjectLinesFor(this.templateID);
      this.initForm();
    },
    async fetchTemplate() {
      try {
        return await shareTemplateService.getTemplate(this.templateID);
      } catch (e) {
        await this.$router.replace({name: 'admin.share_templates.index'});
      }
    },
    initForm() {
      this.form.name = this.template.name;
      this.form.locale = this.template.locale; // MLD-5385
      this.form.is_featured = this.template.is_featured;
      this.form.is_web = this.template.is_web;
      this.form.is_app = this.template.is_app;
      this.form.is_gmail = this.template.is_gmail;
      this.form.is_outlook = this.template.is_outlook;
      this.form.user_id = this.template.user_id ? this.template.user_id : '';
      this.form.subject = this.template.subject;
      this.form.is_subject_editable = this.template.is_subject_editable; // MLD-2695
      this.form.editor = this.template.editor; // MLD-2473
      this.form.design = this.template.design; // MLD-2473
      this.form.html_head = this.template.html_head ? this.template.html_head : ''; // MLD-2620
      this.form.css = this.template.css ? this.template.css : ''; // MLD-2910
      this.form.html_body = this.template.html_body;
      this.form.preheader_text = this.template.preheader_text; // MLD-2892
      this.form.shared_link_url_parameters = this.template.shared_link_url_parameters; // MLD-2954
      this.form.text_body = this.template.text_body;
      this.form.sms_body = this.template.sms_body;
      this.form.status = this.template.status;
      this.form.is_editable = this.template.is_editable;
      this.form.is_quick_share = this.template.is_quick_share; // MLD-2757
      this.form.is_default = this.template.is_default;
      this.form.is_campaign = this.template.is_campaign; // MLD-2524
      this.form.personal_message_allowed = this.template.personal_message_allowed; // MLD-3998
      this.form.personal_message_required = this.template.personal_message_required; // MLD-3998
      this.form.can_be_copied = this.template.can_be_copied; // MLD-2097
      this.form.can_be_selected = this.template.can_be_selected; // MLD-4653
      this.form.can_share_links = this.template.can_share_links; // MLD-2695
      this.form.attachment_url = this.template.attachment_url; // MLD-3420
      this.form.attach_file = this.template.attach_file; // MLD-1112
      this.form.sanitize_attachment_name = this.template.sanitize_attachment_name; // MLD-1609
      this.form.presentations = this.template.presentations.map(p => p.id);
      this.form.instructions = this.template.instructions; // MLD-3031
      // MLD-2325
      this.form.asset_id = this.template.asset_id;
      this.form.release_at = this.template.release_at ? moment.utc(this.template.release_at).format('YYYY-MM-DD') : null;
      this.form.expires_at = this.template.expires_at ? moment.utc(this.template.expires_at).format('YYYY-MM-DD') : null;
      // MLD-2327
      this.form.folder_id = this.template.folder_id ? this.template.folder_id : '';
      this.form.smart_email_bcc_enabled = this.template.smart_email_bcc_enabled; // MLD-2476
      this.form.bcc_recipients = this.template.bcc_recipients.join(','); // MLD-5567
      this.form.cc_recipients = this.template.cc_recipients.join(','); // MLD-5566
      this.form.groups = this.template.groups.map(g => g.id); // MLD-2482, MLD-2760
      this.form.brand_id = this.template.brand_id ?? ''; // MLD-4796
      this.form.subjects = this.subjectLines; // MLD-6517
      if (this.form.subjects.length === 0) {
        this.form.subjects.push({
          id: null,
          position: 1,
          subject: this.template ? this.template.subject : '',
        });
      }

      if (this.form.groups.length) {
        this.form.accessControl = 'Groups';
      } else if (this.form.user_id) {
        this.form.accessControl = 'User';
      } else {
        this.form.accessControl = 'Everyone';
      }
    },
    submit(close = false) {
      if (this.form.busy) {
        return;
      }
      if (this.isAccessEveryone) { // MLD-4854
        // Clear the Groups and User
        this.form.groups = [];
        this.form.user_id = '';
      } else if (this.isAccessGroups) {
        // Clear the user
        this.form.user_id = '';
      } else if (this.isAccessUser) {
        // Clear the groups
        this.form.groups = [];
      }
      // MLD-2863
      const form = this.form.data();
      form.groups = form.groups.map(g => isObject(g) ? g.id : g);
      form.bcc_recipients = form.bcc_recipients ? form.bcc_recipients.split(',') : null; // MLD-5567
      form.cc_recipients = form.cc_recipients ? form.cc_recipients.split(',') : null; // MLD-5566
      this.form.put(`/api/share-templates/${this.template.id}`, {data: form})
        .then(response => {
          //this.$vuetify.goTo(0, { easing: 'easeInOutCubic', duration: 300}); // MLD-4796
          this.$store.commit('setSuccessMessage', 'Template Updated');
          /*if (this.form.folder_id) {
            this.$store.dispatch('setActiveFolderID', this.form.folder_id);
          } else {
            this.$store.dispatch('setActiveFolderID', -1);
          }*/
          this.$store.dispatch('setActiveFolderID', -1);
          this.$store.dispatch('fetchShareTemplates');
          if (close) {
            if (this.$root.isAdminRoute) {
              this.$router.push({name: 'admin.share_templates.index'});
            } else {
              this.$router.push({name: `${this.$root.routePrefix}.share_templates.index`});
            }
          }
        })
        .catch(() => {
        });
    }
  }
}
</script>
